module.exports = __webpack_public_path__ + "static/media/bg-banner-providers.c6493f05.jpg";